<template>
  <a-config-provider :locale="getLocalConfigProvider()">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-card>
          <a-form :form="form">
            <a-form-item label="Alocate Compensation">
              <!-- style="height: 64px!important" -->
              <a-select showSearch 
                v-decorator="['kompensasi', { rules: [{ required: true }] }]" 
                placeholder="Select Compensation"
                dropdownClassName="fitsize"
                :disabled="collectData.status_besar == 'Release'"
                :filter-option="filterOptionCompensation"
                @change="changeCompensation"
                >
                <a-select-option v-for="item in compensationSource" :key="item.kompensasi_id">
                <div>
                  <span>{{ item.spt_no }}</span>
                    <div style="margin-left:12px;border-left: 1px solid red;padding-left: 5px">
                      <div><b>Used to : </b>{{ item.jns_pajak_pemakaian_label }}</div>
                      <div><b>Periode : </b>{{ item.masa_pajak_pemakaian_label }}</div>
                      <div><b>Type : </b>{{ item.jns_kompensasi }}</div>
                      <div><b>Value : </b>{{ formatCurrency("IDR",item.value_kompensasi) }}</div>
                    </div>
                </div>
                </a-select-option>
              </a-select>
              <div class="m-form-description-small">
                <a-row :gutter="8">
                  <a-col :span="6"><b>Used to</b></a-col> <a-col>: {{ selectedCompensationDesc.used_to }}</a-col>
                </a-row>
                <a-row :gutter="8">
                  <a-col :span="6"><b>Periode</b></a-col> <a-col>: {{ selectedCompensationDesc.periode }}</a-col>
                </a-row>
                <a-row :gutter="8">
                  <a-col :span="6"><b>Type</b></a-col> <a-col>: {{ selectedCompensationDesc.type }}</a-col>
                </a-row>
                <a-row :gutter="8">
                  <a-col :span="6"><b>Value</b></a-col> <a-col>: {{ selectedCompensationDesc.value != "" ? formatCurrency("IDR", selectedCompensationDesc.value) : "" }}</a-col>
                </a-row>
              </div>
            </a-form-item>
          </a-form>
          <a-button type="primary" class="margin-top" style="float:right"
            :loading="loading.add"
            @click="handleAdd"
            :disabled="collectData.status_besar == 'Release'"
          >
            Add
          </a-button>
        </a-card>
        <!-- <a-list bordered item-layout="horizontal" class="margin-top">
          <a-list-item :class="collectData && collectData.information.total<0 ? 'bg_green' : 'bg_red'">
            <a-list-item-meta>
              <span slot="title">Total (PPN Keluaran - PPN Masukan)</span>
              <a-avatar
                slot="avatar"
                style="backgroundColor:#87d068"
                icon="tag"
                size="small"
              />
              <div slot="description">
                <h3>{{ formatRupiah(collectData.information ? collectData.information.total : 0) }}</h3>
              </div>
            </a-list-item-meta>
          </a-list-item>
          <a-list-item :class="'bg_red'">
            <a-list-item-meta>
              <span slot="title">Total Compensation</span>
              <a-avatar
                slot="avatar"
                style="backgroundColor:#87d068"
                icon="tag"
                size="small"
              />
              <div slot="description">
                <h3>{{ formatRupiah(total_compensation ? total_compensation : 0) }}</h3>
              </div>
            </a-list-item-meta>
          </a-list-item>
          <a-list-item style="background:whitesmoke">
            <a-list-item-meta>
              <span slot="title">Total Value
                <span :style="hitung.value<0?'color:green': 'color:red'" >({{ hitung.lbl.toUpperCase() }})</span>
              </span>
              <span slot="description" style="font-size: medium;">{{ formatRupiah(hitung.value) }}</span>
            </a-list-item-meta>
          </a-list-item>
        </a-list> -->
        <a-config-provider :locale="getLocalConfigProvider()">
          <a-list bordered item-layout="horizontal" class="margin-top" :data-source="data_col_left">
          <a-list-item slot="renderItem" slot-scope="item, index"
          :class="item.title=='Total Compensation' ? 'bg_green' : (item.value ? (item.value < 0 ? 'bg_green' : 'bg_red') : 'bg_grey')"
          >
            <a-list-item-meta>
                <span slot="description" v-if="data_col_left.length - 1 != index">{{ item.description }}</span>
                <span slot="description" v-else style="font-size: medium;">{{ item.description }}</span>
                <span v-if="data_col_left.length - 1 != index" slot="title">{{ item.title }}</span>
                <h3 v-else slot="title">{{ item.title }} (
                  <span :style="infoKompensasi.total_nilai_label=='Lebih Bayar' ? 'color:green' : 'color:red'">
                    {{ infoKompensasi.total_nilai_label == 'Lebih Bayar' ? 'Overpayment' : 'Insufficient Payment' }}
                  </span>
                )
                </h3>
                <a-avatar
                  v-if="data_col_left.length - 1 != index"
                  slot="avatar"
                  style="backgroundColor:#87d068"
                  icon="tag"
                  size="small"
                />
              </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-config-provider>
      <a-form-item label="Note"
        v-if="infoKompensasi && infoKompensasi.total_nilai_label != 'Lebih Bayar'"
      >
        <a-textarea
          placeholder="Write the note here ... "
          :rows="3"
          v-model="note"
        />
      </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <div class="container-headertable">
          <div class="m-display-flex space-between align-middle">
              <span>List Details</span>
              <!-- <span></span> -->
          </div>
        </div>
          <a-config-provider :locale="getLocalConfigProvider()">
            <a-table
              bordered
              size="small"
              id="tbl_dtl"
              :rowKey="(record, index) => { return index; }"
              :columns="columns"
              :dataSource="data_source"
              :pagination="pagination"
              :scroll="{ x: 565 }"
            >
              <template slot="title">
                <a-input-search v-model="search" @change="searching" placeholder="Quick Search" />
              </template>
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{
                  (pagination.page - 1) * pagination.pageSize + index + 1
                }}</span>
              </template>
              <template slot="notrans" slot-scope="text, data">
                {{ data.spt_no }}
              </template>
              <template slot="tax_type_date" slot-scope="text, data">
                <b>{{ data.jns_pajak_pemakaian_label }}</b> /<br/>
                <span>{{ data.masa_pajak_pemakaian_label }}</span>
            
              </template>
              <template slot="val" slot-scope="text, data">
                  <span style="float:right">{{
                    formatCurrency("IDR", data.value_kompensasi)
                  }}</span>
              </template>
              <template slot="type" slot-scope="text, data">
                {{ data.jns_kompensasi }}<br/>
                <a-button v-if="data.jns_kompensasi == 'PBK'"
                @click="viewPBK(data.file_doc_pbk_path)"
                size="small">
                  View
                </a-button>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button type="danger" size="small" icon="close" @click="handleDelete(data.kompensasi_id)"
                :disabled="collectData.status_besar == 'Release'"
                :loading="loading.delete && loading.key==data.kompensasi_id"
                ></a-button>
              </template>
            </a-table>
          </a-config-provider>
      </a-col>
    </a-row>
  </a-config-provider>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod";
import _ from "lodash";

export default {
  name: "Compensation",
  mixins: [CurrencyFormat, GlobalMethod],
  props: ["collectData","catatan"],
  components: {},
  data() {
    const columns = [{
      title: "#",
      key: "nomor",
      align: "center",
      scopedSlots: { customRender: "nomor" },
      width: 40,
    },
    {
      title: "No.Transaction",
      key: "notrans",
      scopedSlots: { customRender: "notrans" },
      width: 180,
    },
    {
      title: "Tax Type / Tax Date",
      key: "tax_type_date",
      align: "center",
      scopedSlots: { customRender: "tax_type_date" },
      width: 125,
    },
    {
      title: "Type",
      key: "type",
      align: "center",
      scopedSlots: { customRender: "type" },
      width: 120,
    },
    {
      title: "Value",
      key: "val",
      align: "center",
      scopedSlots: { customRender: "val" },
      width: 150,
    },
    {
      title: "Action",
      align: "center",
      fixed:"right",
      scopedSlots: { customRender: "aksi" },
      width: 75,
    }];
    return {
      columns,
      data_source: [], 
      data_sourceOri: [],
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      compensationSource: [],
      loading: {
        add: false,
        delete: false,
        key: "",
      },
      search: "",
      data_col_left: [],
      infoKompensasi: null,
      selectedCompensationDesc: {
        used_to: "",
        periode: "",
        type: "",
        value: ""
      },
      note:'',
    };
  },
  beforeCreate() {
  },
  created() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getScreen", "getSatuan", "getAuth","getType_tax"]),
    initialData() {
      if (this.listWO === undefined || this.listWO.length <= 0) {
        return {
          id_wo_dtl: "",
          item_name: "",
          jumlah: 0,
          satuan: "",
          harga: 0,
          hargaTotal: 0,
        };
      } else {
        return {
          id_wo_dtl: this.listWO.id_wo_dtl,
          item_name: this.listWO.item_name,
          jumlah: this.listWO.jumlah,
          satuan: this.listWO.satuan,
          harga: this.listWO.harga,
          hargaTotal: this.listWO.hargaTotal,
        };
      }
    },
    total_compensation() {
      let result = 0;
      this.data_sourceOri.forEach(element => {
        result += Number(element.value_kompensasi);
      });
      return result;
    },
    hitung() {
      let text = this.collectData.information.grandtotal - this.total_compensation < 0 ? 'overpayment' : 'insufficient payment'
      Event.$emit("triggerNext", {text: text});
      return {
        lbl: text,
        value: this.collectData.information.grandtotal - this.total_compensation
      }
    }
  },
  activated() {
    Event.$emit("pgloading", true);
    this.asyncAxiosGet("spt/kompensasi", this.getAuth, {
      spt_id: this.collectData.information.spt_id,
      pembetulan: (this.collectData.pembetulan ? this.collectData.pembetulan.tipe_pembetulan : null),
    })
      .then((res) => {
        let tresult = res.list_detail;
        for (let i = 0; i < tresult.length; i++) {
          tresult[i].value_kompensasi = tresult[i].value_kompensasi < 0 ? tresult[i].value_kompensasi * -1 : tresult[i].value_kompensasi;
        }
        this.compensationSource = res.kompensasi;
        this.data_source = tresult;
        this.data_sourceOri = tresult;
        this.infoKompensasi = res.information
        this.mountData();
        Event.$emit("pgloading", false);
    })
      .catch((err) => {
        Event.$emit("pgloading", false);
        Event.$emit("sptData", {
          from:"back"
        });
      // let responses = Object.assign({}, err.response.data);
      //   this.displayMessageValue("error-other", responses.message);
    });
  },
  beforeDestroy() {
  },
  methods: {
    handleAdd() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.loading.add = true;
        Event.$emit("disableNext", true);
        let data = new FormData();
        data.append("spt_id", this.collectData.information.spt_id);
        data.append("kompensasi_id", values.kompensasi);
        this.asyncAxiosPost("spt/kompensasi", "formdata", this.getAuth, data)
          .then((res) => {
            this.infoKompensasi = res.information;
            this.compensationSource = res.kompensasi;
            let tresult = res.list_detail;
            for (let i = 0; i < tresult.length; i++) {
              tresult[i].value_kompensasi = tresult[i].value_kompensasi < 0 ? tresult[i].value_kompensasi * -1 : tresult[i].value_kompensasi;
            }
            this.data_source = tresult;
            this.data_sourceOri = tresult;
            this.form.resetFields();
            this.selectedCompensationDesc = {
              used_to: "",
              periode: "",
              type: "",
              value: ""
            };
            this.mountData();
            this.loading.add = false;
            Event.$emit("disableNext", false);
          })
          .catch((err) => {
            this.loading.add = false;
            Event.$emit("disableNext", false);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      });
    },
    handleDelete(val) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.delete = true;
          Event.$emit("disableNext", true);
          that.loading.key = val;
          let data = new FormData();
          data.append("spt_id", that.collectData.information.spt_id);
          data.append("kompensasi_id", val);
          that.asyncAxiosPost("spt/hapus_kompensasi", "formdata", that.getAuth, data)
            .then((res) => {
              that.infoKompensasi = res.information;
              that.compensationSource = res.kompensasi;
              let tresult = res.list_detail;
              for (let i = 0; i < tresult.length; i++) {
                tresult[i].value_kompensasi = tresult[i].value_kompensasi < 0 ? tresult[i].value_kompensasi * -1 : tresult[i].value_kompensasi;
              }
              that.data_source = tresult;
              that.data_sourceOri = tresult;
              that.loading.delete = false;
              that.mountData();
              Event.$emit("disableNext", false);
              that.loading.key = "";
            })
            .catch((err) => {
              that.loading.delete = false;
              Event.$emit("disableNext", false);
              that.loading.key = "";
              let responses = Object.assign({}, err.response.data);
              that.displayMessageValue("error-other", responses.message);
            });
        },
        onCancel() { },
      });
    },
    searching(val) {
      val = val.target.value;
      this.data_source = [];
      if (val) {
        this.data_source = _.filter(this.data_sourceOri, (item) =>
          item.spt_no.toLowerCase().indexOf(val.toLowerCase()) > 0 ||
          item.jns_pajak_pemakaian_label.toLowerCase().indexOf(val.toLowerCase()) > 0 ||
          item.masa_pajak_pemakaian_label.toLowerCase().indexOf(val.toLowerCase()) > 0 ||
          this.formatCurrency("IDR", item.value_kompensasi).toLowerCase().indexOf(val.toLowerCase()) > 0
        );
      } else {
        this.data_source = this.data_sourceOri;
      }
    },
    handleRef() {
      if (this.hitung.lbl=='insufficient payment' && this.collectData.status_besar != null && this.collectData.status_besar!='Release') {
        this.$confirm({
          title: "Are you sure to release this data?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            Event.$emit("sptData", { from: "next" });
          },
          onCancel() { },
        });
      } else {
        Event.$emit("sptData", { from: "next" });
      }
    },
    handleRefSubmit() {
      Event.$emit("sptData", {
        from: "submit",
        extra: {
          note: this.note,
          is_draft: '0'
        },
      });
    },
    mountData() {
      this.data_col_left = [
        {
          title: "Total (PPN Keluaran - PPN Masukan)",
          description: this.collectData.information ? this.formatRupiah(this.collectData.information ? this.collectData.information.total : 0) : "",
          value: this.collectData.information ? this.collectData.information.total : 0
        }, {
          title: "Total Compensation",
          description: this.formatRupiah(this.total_compensation ? this.total_compensation : 0),
          value: this.total_compensation ? this.total_compensation : 0
        }, {
          title: "Total Value",
          description: this.hitung.value ? this.formatRupiah(this.hitung.value) : "",
          value: null
        },
      ];

      if (this.collectData.information.jenis_spt.includes('PPh21')) {
        this.data_col_left = [
          {
            title: "Total PPh21",
            description: this.collectData.information ? this.formatRupiah(this.collectData.information ? this.collectData.information.grandtotal : 0) : "",
            value: (this.collectData.information ? this.collectData.information.grandtotal : 0)
          }, {
            title: "Total Compensation",
            description: this.formatRupiah(this.total_compensation ? this.total_compensation : 0),
            value: -1*(this.total_compensation == 0 ? 1 : this.total_compensation)
          }, {
            title: "Total Value",
            description: this.hitung.value ? this.formatRupiah(this.hitung.value) : "",
            value: null
          },
        ];
      } else if (this.collectData.information.jenis_spt.includes('SPT Unifikasi')) {
        this.data_col_left = [
          {
            title: "Total Unifikasi Value",
            description: this.collectData.information ? this.formatRupiah(this.collectData.information ? this.collectData.information.total : 0) : "",
            value: (this.collectData.information ? this.collectData.information.total : 0)
          }, {
            title: "Total Compensation",
            description: this.formatRupiah(this.total_compensation ? this.total_compensation : 0),
            value: -1 * (this.total_compensation == 0 ? 1 : this.total_compensation)
          }, {
            title: "Total Value",
            description: this.hitung.value ? this.formatRupiah(this.hitung.value) : "",
            value: null
          },
        ];
      }

      if (this.catatan) {
        this.note = this.catatan;
      }
    },
    viewPBK(url) {
      window.open(this.$serviceUrl + url);
    },
    filterOptionCompensation(input, option) {
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    changeCompensation(val) {
      let txt = _.filter(this.compensationSource, (el) => el.kompensasi_id == val);
      this.selectedCompensationDesc = {
        used_to: txt[0].jns_pajak_pemakaian_label,
        periode: txt[0].masa_pajak_pemakaian_label,
        type: txt[0].jns_kompensasi,
        value: txt[0].value_kompensasi
      }
    },
    handleRefDraft() {
      Event.$emit("sptData", {
        from: "submit",
        extra: {
          note: this.note,
          is_draft: 1,
        }
      });
    }
  },
};
</script>

<style lang="less">
.bg_red{
  background: fade(red, 20%);
}
.bg_green{
  background: fade(green, 20%);
}
.bg_grey{
  background: fade(black, 20%);
}
// #kompensasi .ant-select-selection--single{
//     height: 64px!important;

// }

#kompensasi .ant-select-selection-selected-value{
  overflow: hidden;
  height: 24px;
}

.fitsize{
  //width:fit-content!important;
  overflow: hidden;
}
</style>